import React, { useRef } from 'react';
import { SActionBtn, SLowcodeList, SMessage, STableActions } from 'shj-components'
import config from './config.json';
import { message, Select } from 'antd';
import { addOrEditFn } from './addOrEdit/index';
import KeepAlive from 'react-activation';
import { tableApiFunc } from "@/utils/data.ts";
import { qualityMoneyConfigDelete, qualityMoneyConfigPage } from "@/services/qualityMoneyAccount.ts";
import { useRequest } from "ahooks";
import { getWorkTypeList } from "@/services";
import { moneyRender } from "@/utils";
import AuthConfig from '@/config/authConfig';

const Page = (props: any) => {
    const listRef = useRef<any>();
    const { Option } = Select;

    let { data: workTypeList = [], runAsync: runAsyncWorkType } = useRequest(getWorkTypeList, { manual: true });
    let { runAsync: runAsyncDelete } = useRequest(qualityMoneyConfigDelete, { manual: true });

    const getStatusOptions = () => {
        return new Promise(async (resolve, reject) => {
            try {
                const workTypeList = await runAsyncWorkType();
                resolve({
                    workTypeList
                });
            } catch (e) {
            }
        });
    };

    const delEvent = (id: any) => {
        const dialog = SMessage.delete({
            onOk: async () => {
              try {
                const res: any = await runAsyncDelete(id)
                if (res.errorCode === 0) {
                  message.success('删除成功');
                  listRef.current.reload();
                } else {
                  message.error('删除失败');
                }
              } catch (err) {
                console.log(err)
              }
              dialog?.destroy();
            },
            onCancel: () => {
              message.warning('取消删除');
              dialog?.destroy();
            },
          });
    };

    // 新增or编辑
    const onAddOrEdit = async (record: any) => {
        addOrEditFn({
            fn: () => {
                listRef.current.reload();
            },
            ...record,
            record: record,
            companyList: props.companyList,
            workTypeList,
            // workerTypeList,
        });
    };

    const extension = {
        request: {
            fetchList: tableApiFunc(qualityMoneyConfigPage, { fieldNames: { current: 'current' }, }),
            getStatusOptions
        },
        events: { onAddOrEdit: () => onAddOrEdit(null) },
        status: {
            btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
        },
        customRender: {
            setentryPaymentAmount(text: any, record: any) {
                return <span>{moneyRender(text)}</span>;
            },
            settotalPaymentAmount(text: any, record: any) {
                return <span>{moneyRender(text)}</span>;
            },
            setCompany({ key, name, form }: any) {
                return (
                    <Select
                        mode="multiple"
                        showSearch
                        allowClear={true}
                        filterOption={(input: any, option: any) => {
                            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        }}
                        onChange={(value) => {
                            form.setFieldsValue({
                                [name]: value,
                            });
                        }}
                    >
                        {props.allCompanyList.map((item: any, i: any) => {
                            return (
                                <Option key={i} value={item.orgId}>
                                    {item.companyName}
                                </Option>
                            );
                        })}
                    </Select>
                );
            },
            setWorkType({ key, name, form }: any) {
                return (
                    <Select
                        mode="multiple"
                        showSearch
                        allowClear={true}
                        filterOption={(input: any, option: any) => {
                            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        }}
                        onChange={(value) => {
                            form.setFieldsValue({
                                [name]: value,
                            });
                        }}
                    >
                        {workTypeList.map((item: any, i: any) => {
                            return (
                                <Option key={i} value={item.id}>
                                    {item.name}
                                </Option>
                            );
                        })}
                    </Select>
                );
            },
            setAction(text: any, record: any) {
                return <STableActions>
                        <SActionBtn
                            auth={AuthConfig.editMoneyChange}
                            onClick={() => {
                                onAddOrEdit(record);
                            }}
                        >
                            编辑
                        </SActionBtn>
                        <SActionBtn 
                            danger
                            auth={'delMoneyChange'}
                            onClick={() => delEvent(record.id)}>
                            删除
                        </SActionBtn>
                    </STableActions>
            },
        },
    };

    return <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />;
};

export default (props: any) => {
    return (
        <KeepAlive name={location.pathname} id={'keep' + location.pathname}>
            <Page {...props} />
        </KeepAlive>
    );
};
